import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, switchMap, throwError } from 'rxjs';
import { secureRoutes } from 'app/auth/auth.config';
import { Router } from '@angular/router';

let loginRedirectInProgress = false;

export const httpErrorInterceptorFn: HttpInterceptorFn = (request, next) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return next(request).pipe(
    catchError((error: unknown) => {
      const isProtectedApiRequest = secureRoutes.some(
        (prefix) => request.url.startsWith(prefix) || request.url.includes(prefix),
      );

      if (!isProtectedApiRequest) {
        return throwError(() => error);
      }

      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          if (loginRedirectInProgress) {
            return throwError(() => error);
          }

          return oidcSecurityService.isAuthenticated$.pipe(
            switchMap(({ isAuthenticated }) => {
              if (!isAuthenticated) {
                loginRedirectInProgress = true;
                oidcSecurityService.authorize();
              }

              return throwError(() => error);
            }),
          );
        }
        if (error.status === 403) {
          void router.navigate(['/forbidden']);
        }
      }
      return throwError(() => error);
    }),
  );
};
